import axiosInstance from './axiosConfig';

export const getCategoriesApi = () => axiosInstance.get('/categories');
export const createCategoryApi = (payload) => axiosInstance.post('/categories', payload);
export const updateCategoryApi = (id, payload) => axiosInstance.put(`/categories/${id}`, payload);
export const deleteCategoryApi = (id) => axiosInstance.delete(`/categories/${id}`);
